// Course 1: AI at Work 101.
//
// Locked decisions this file implements (AI courses handoff, 2026-10-08):
//   - covers ChatGPT, Claude and Gemini; the learner picks their own tool
//   - text, screenshots and exercises; no video in the first pass, but every
//     lesson carries a hidden video slot
//   - tool tabs ONLY on steps where the clicks actually differ
//   - every exercise uses the learner's own real work
//   - Lesson 1.1 is the free sample lesson in Preview
//   - the preview opens with outcomes, not tool features
//
// `status: 'ready'` means the lesson has been written and approved and has a
// page behind it. 'draft' means it is listed as coming soon. Lesson 1.2 was
// written and approved in the handoff; the rest are drafted for Leena's review
// before they flip to ready.

import lesson11 from './lessons/l1-1-your-ai-your-job.js';
import lesson12 from './lessons/l1-2-safe-by-default.js';
import lesson13 from './lessons/l1-3-prompts-that-work.js';
import lesson14 from './lessons/l1-4-sound-like-you.js';
import lesson15 from './lessons/l1-5-teach-it-who-you-are.js';
import lesson16 from './lessons/l1-6-capstone.js';

export default {
  key: 'ai_at_work_101',
  title: 'AI at Work 101',
  blurb: 'Get output that sounds like you, from an AI that already knows how you work.',
  minutes: 100,

  // The Preview page opens with these. Outcomes, never tool features.
  outcomes: [
    'Output that sounds like you, not generic AI slop',
    'An AI that already knows who you are and how you work, so you stop repeating yourself',
    'Your own library of five prompts for real tasks in your job',
    'Confidence about what is safe to paste and what is not',
    'For owners: a ready-to-edit AI policy and security FAQ for your team',
  ],

  // Shown to everyone at the client. There is no buyer flag in the data model,
  // so this is not restricted to whoever paid.
  ownerKit: {
    title: 'Owner Kit',
    blurb: 'Three things for whoever bought the course, not the learners.',
    items: [
      { key: 'security_faq', title: 'AI security FAQ',
        body: 'The questions teams actually ask. Is our data safe, who can see it, does it train on our work, what about client information, and which plan should we pay for.' },
      { key: 'settings_guide', title: 'Training off, memory on',
        body: 'The settings that matter in each tool, what stays private and what does not, and why memory is worth keeping on even when training is off.' },
      { key: 'usage_policy', title: 'AI usage policy template',
        body: 'An editable policy for your team: approved tools, the never-paste list, and how to check work before it goes out.' },
    ],
  },

  sampleLessonKey: '1-1',

  // The two time estimates that bracket the course. The answers are the
  // before-and-after number the upsell conversation rests on.
  timeEstimate: {
    startQuestion: 'Roughly how many hours a week do you spend on admin: email, documents, writing things up?',
    endQuestion: 'Same question again. And how much time do you think you saved?',
  },

  // All six approved by Leena on 2026-10-09 and converted mechanically from
  // the drafts. 1.1 is the free sample, which is what the preview opens.
  lessons: [lesson11, lesson12, lesson13, lesson14, lesson15, lesson16],
};
